import { COLOR_TYPE_OFFLINE } from "../../../../utils/constants";


const OfflineBanner = () => {
  return (
    <div
      className="px-2.5 py-0.5 font-semibold"
      style={{ backgroundColor: COLOR_TYPE_OFFLINE, color: "#696969" }}
    >
      <span className="px-2.5">
        You are offline. Some functionalities are not available.
      </span>
    </div>
  );
};

export default OfflineBanner;
